import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';

import Icon from 'components/UI/Icon';
import News from './components/News';

import FiltersData from '@/mocks/blogSecFilter.js';
import { BLOG_PAGE } from '@/constants/pagesUrl.js';
import useIntersection from 'hooks/useIntersection';
import useLocaleTxt from 'hooks/useLocaleTxt';

import * as styles from './blog.module.scss';

const Blog = ({ data }) => {
  const { scrollWrapper, inViewSec, inViewRefSec } = useIntersection({
    threshold: 0.3,
  });
  const localeTxt = useLocaleTxt();

  return (
    <section className={classnames(styles.section)} ref={scrollWrapper}>
      <div className="cr-wrap">
        <div
          className={classnames(styles.inner, inViewSec && styles.jsAnimInit)}
        >
          <div className={classnames(styles.header)} ref={inViewRefSec}>
            <p
              className={classnames(styles.subtitle, 'cr-subheader cr-text-3')}
            >
              {data.subtitle && data.subtitle}
            </p>
            <h2 className={classnames('cr-h2')}>{data.title}</h2>
          </div>
          <News filters={FiltersData} />

          <Link
            to={BLOG_PAGE}
            className={classnames(
              styles.link,
              'cr-btn cr-btn--icon cr-btn--icon-arrow cr-btn--large cr-btn--wide cr-btn--icon-red-txt'
            )}
          >
            {localeTxt['BLOG_READ_MORE']}
            <Icon name="corner-arrow-small-bold" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Blog;
